import React from 'react';

import { CrownFilledIcon, CupFilledIcon } from '@icons';

import { PromotionWinnerType } from '@types';

import * as Styled from './winner-row.styled';

type OwnProps = {
	winner: PromotionWinnerType;
	isHighlight?: boolean;
};

const WinnerRow: React.FC<OwnProps> = ({ winner, isHighlight }) => {
	return (
		<Styled.Wrapper $isHighlight={isHighlight}>
			<Styled.Place>
				<Styled.CrownIconWrapper $isActive={isHighlight}>
					<CrownFilledIcon />
				</Styled.CrownIconWrapper>
				{winner.position}
			</Styled.Place>
			<Styled.Participant>{winner.user_pm_id}</Styled.Participant>
			<Styled.Prize>
				<Styled.CupIconWrapper>
					<CupFilledIcon />
				</Styled.CupIconWrapper>
				{winner.prize_name}
			</Styled.Prize>
		</Styled.Wrapper>
	);
};

export default WinnerRow;
